// @flow
import React, { Component } from 'react'
import styled, { type StyledComponent } from 'styled-components'
import postMultiPart from '../../services/postMultiPart'
import ErrorText from '../controls/ErrorText'
import Select from '../controls/Select'
import Button from '../controls/PrimaryButton'
import type { OptionType } from '../types'
import FileUploadComponent from '../FileUploadComponent'

const FormWrapper: StyledComponent<Object, any, any> = styled.div`
  width: 460px;
`
const InputGroup: StyledComponent<Object, any, any> = styled.div`
  font-size: 14px;
  padding-bottom: 12px;
`
const TextInput: StyledComponent<Object, any, any> = styled.input`
  width: 100%
  max-width: 460px;
`
const Instruction: StyledComponent<Object, any, any> = styled.div`
  font-size: 14px;
  line-height: 18px;
  padding-bottom: 14px;
`
const UploadWrapper: StyledComponent<Object, any, any> = styled.div`
  padding-bottom: 10px;
`
type Errors = Array<string>

type Props = {|
  onClose: Function,
  onObjectCreated: Function
|}

type State = {|
  file: any,
  fileErrors: Errors,
  isLoading: boolean,
  kind: string,
  kindErrors: Errors,
  name: string,
  nameErrors: Errors
|}

const t = {
  kind: 'Выберите тип списка контактов',
  label: 'Загрузить контакты',
  name: 'Название',
  phone: 'Телефон',
  email: 'Email',
  vk_id: 'ID ВКонтакте',
  instruction:
    'Вы можете загрузить файл в формате TXT, содержащий Адреса электронной почты, Номера телефонов или ID пользователей ВКонтакте для показа рекламы по этим контактам. Каждый контакт указывайте с новой строки. Минимальный размер файла от 3000 контактов. Формат телефонов: 79215554433.',
  save: 'Сохранить контакты',
  learn_more: 'Узнать подробнее',
  upload: 'Выбрать файл...',
  wrong_file_extension: 'Расширение файла не поддерживается'
}

const BLOG_URL = '/ru/blog/targeting-ads-by-email-and-phone/'
const CREATE_CONTACT_URL = '/api/v1/contacts'

export default class ContactForm extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      file: null,
      fileErrors: [],
      isLoading: false,
      kind: '',
      kindErrors: [],
      name: '',
      nameErrors: []
    }
  }

  render() {
    return (
      <FormWrapper>
        <h2>{t.label}</h2>
        <InputGroup>
          <TextInput
            className="input-item"
            name="contact_name"
            disabled={this.state.isLoading}
            placeholder={t.name}
            value={this.state.name}
            onChange={(e) => this.setState({ name: e.target.value })}
          />
          <ErrorText errors={this.state.nameErrors} />
        </InputGroup>
        <InputGroup className="t-ContactKindSelect">
          <Select
            value={this.state.kind}
            placeholder={t.kind}
            options={this.kindOptions()}
            disabled={this.state.isLoading}
            onChange={(kind) => this.setState({ kind })}
          />
          <ErrorText errors={this.state.kindErrors} />
        </InputGroup>
        <Instruction>
          {t.instruction}{' '}
          <a href={BLOG_URL} target="_blank">
            {t.learn_more}
          </a>
        </Instruction>
        <UploadWrapper>
          <FileUploadComponent
            id="contact_file"
            browseText={t.upload}
            validExtensions={['.txt']}
            onSuccessChange={(fileElement) => {
              this.setState({ file: fileElement.files[0] })
            }}
            wrongExtensionText={t.wrong_file_extension}
          />
          <ErrorText errors={this.state.fileErrors} />
        </UploadWrapper>
        <Button onClick={() => this.createContact()}>{t.save}</Button>
      </FormWrapper>
    )
  }

  createContact() {
    this.setState({ isLoading: true })
    let data = new window.FormData()
    data.append('contact[file]', this.state.file)
    data.append('contact[kind]', this.state.kind)
    data.append('contact[name]', this.state.name)

    postMultiPart(CREATE_CONTACT_URL, data)
      .done((response) => {
        this.props.onClose()
        this.props.onObjectCreated(response.data)
      })
      .fail(({ responseJSON }: any) => {
        this.setState({
          fileErrors: responseJSON.message.file || [],
          kindErrors: responseJSON.message.kind || [],
          nameErrors: responseJSON.message.name || []
        })
      })
      .always(() => this.setState({ isLoading: false }))
  }

  kindOptions(): Array<OptionType> {
    return [
      { id: 'phone', name: t.phone },
      { id: 'email', name: t.email },
      { id: 'vk_id', name: t.vk_id }
    ]
  }
}
